import { loaderAction, setRemoveDataFormAction } from "../rootReducer";
import growl from "../../lib/growl/growl";
import { setLocalStorage } from "../../helpers/LocalStorage";
import { api } from "../../helpers/api";
import { REMOVE_DATA_FORM_INITIAL } from "../initialStateConstant";

export const RemoveDataThunk = (args) => async (dispatch, getState) => {
    const { user } = getState();

    dispatch(loaderAction(true));

    try {
        let formData = new FormData();
        formData.append('user_id', user.id);
        formData.append('hash', user.hash);

        formData.append('date', args.date);
        formData.append('workouts', args.workouts);
        formData.append('subscriptions', args.subscriptions);
        formData.append('payments', args.payments);
        formData.append('booking', args.booking);

        const response = await api({ data: formData, link: 'remove_data_permanently' });

        // Если не прошли проверку хеша разлогиниваемся
        if (response.void) {
            setLocalStorage('afp_fitness', '').then(() => window.location.reload());
        }

        if (response.success) {
            dispatch(setRemoveDataFormAction(REMOVE_DATA_FORM_INITIAL));
            growl({ type: 'success', message: response.message });
        }
        else if (response.error) {
            growl({ type: 'error', message: response.message });
        }
    }
    catch(error) {
        console.log(error);
    }
    finally {
        dispatch(loaderAction(false));
    }
};